import { Injectable } from '@angular/core'
import { signalState, patchState } from '@ngrx/signals'
import { SearchFeedbackRequestDTO } from '../../../apiModule'

export interface FeedbackHistoryState {
  search: SearchFeedbackRequestDTO
  scroll: number
  isLoading: boolean
  error: string | null
}

const initialState: FeedbackHistoryState = {
  search: {},
  scroll: 0,
  isLoading: false,
  error: null
}

@Injectable({ providedIn: 'root' })
export class FeedbackHistoryStoreService {
  readonly feedbackHistoryState = signalState<FeedbackHistoryState>(initialState)

  updateSearch(search: SearchFeedbackRequestDTO): void {
    patchState(this.feedbackHistoryState, { search })
  }

  updateScroll(scroll: number): void {
    patchState(this.feedbackHistoryState, { scroll })
  }

  setLoading(isLoading: boolean): void {
    patchState(this.feedbackHistoryState, { isLoading })
  }

  setError(error: string | null): void {
    patchState(this.feedbackHistoryState, { error })
  }

  reset(): void {
    patchState(this.feedbackHistoryState, initialState)
  }
}
